<form novalidate #propertyParkingSectionForm="ngForm">
    <tg-row
        class="property-parking-section"
        *ngIf="draftLoaded$ | async"
    >
        <tg-col md="9" sm="12">
            <tg-row>
                <tg-col sm="12">
                    <h2>Parking</h2>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col sm="12">
                    <p>
                        Provide some details about what kind of parking is available at this property.
                    </p>
                </tg-col>
            </tg-row>

            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-select-container label="Garage parking"
                    >
                        <select
                            tgSelect
                            name="garageParking"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.garageParking"
                            [validation]="
                                validation.propertyInformation.garageParking
                                    | toValidator: metadata.garageParking
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.garageParking"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col md="4" sm="12">
                    <tg-select-container label="Off street parking"
                    >
                        <select
                            tgSelect
                            name="offStreetParking"
                            (change)="publish()"
                            [(ngModel)]="draftData.propertyInformation.offStreetParking"
                            [validation]="
                                validation.propertyInformation.offStreetParking
                                    | toValidator: metadata.offStreetParking
                            "
                        >
                            <option [ngValue]="null"></option>
                            <option
                                *ngFor="let opt of metadata.offStreetParking"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>

            <tg-row>
                <tg-col md="8" sm="8">
                    <tg-input-container
                        label="Additional details about parking or garaging"
                        showRemainingCharacters="false"
                    >
                        <textarea
                            tgTextInput
                            name="parking"
                            placeholder="e.g. 1 off street and plenty of on street parking"
                            rows="2"
                            (blur)="publish()"
                            [(ngModel)]="draftData.propertyInformation.parkingDetail"
                            [validation]="
                                validation.propertyInformation.parkingDetail | toValidator
                            "
                        ></textarea>
                    </tg-input-container>
                </tg-col>
            </tg-row>

        </tg-col>
    </tg-row>
</form>
